<template>
  <ol>
    <li>Fazer download do arquivo modelo disponivel no link acima;</li>
    <li>
      Abrir o arquivo em seu editor de planilhas favorito (Microsoft Excel,
      Google Planilhas, outros);
    </li>
    <li>
      Preencher a planilha
      <ol type="a">
        <li>Cada bovino deve ser adicionardo em uma linha;</li>
        <li>Todo bovino deve obrigatoriamente ter brinco, tipo e fazenda;</li>
        <li>
          Os bovinos dos tipos bezerros e bezerras devem ser cadastrados depois
          de suas matrizes;
        </li>
      </ol>
    </li>
  </ol>
  <ul style="padding-left: 20px">
    <li>
      Se o formato for <span class="excel">Excel</span>
      basta salvar e fazer o upload do arquivo;
    </li>
    <li>
      Se o formato desejado for <span class="csv">CSV</span>, salvar o arquivo com colunas separadas por virgúla.
    </li>
  </ul>
</template>

<script>
export default {
  name: 'BovineImportInstruction',
};
</script>

<style scoped>
ol {
  padding-left: 20px;
  line-height: 2rem;
}

ul {
  padding-left: 20px;
  line-height: 2rem;
}

.excel {
  color: #027a0e;
  font-weight: 600;
}

.csv {
  color: gray;
  font-weight: 600;
}
</style>
